import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import withFavorite from 'shared/hocs/withFavorite';
import withFavoritesFetch from 'shared/hocs/withFavoritesFetch';
import { FormattedMessage } from 'react-intl';
import heartRedUrl from './heart-red.svg';
import heartFillRedUrl from './heart-fill-red.svg';
import s from './Favourite.css';

class Favourite extends React.Component {
  static propTypes = {
    imgWidth: PropTypes.number,
    isFavorite: PropTypes.bool,
    id: PropTypes.number.isRequired,
    toggleFavorite: PropTypes.func.isRequired,
    isCompact: PropTypes.bool,
    className: PropTypes.string.isRequired,
  };
  static defaultProps = {
    imgWidth: 22,
    isFavorite: false,
    isCompact: false,
    className: '',
  };

  handleToggleClick = () => {
    this.props.toggleFavorite(this.props.id);
  };

  render() {
    const { imgWidth, isFavorite, className, isCompact } = this.props;

    return (
      <button
        className={cx(s.favourite, className, {
          [s.compact]: isCompact,
          [s.isFavorite]: isFavorite,
        })}
        data-lens-event="addBookmark"
        onClick={this.handleToggleClick}
      >
        <img
          className={s.img}
          src={isFavorite ? heartFillRedUrl : heartRedUrl}
          width={imgWidth}
          height={imgWidth}
          alt=""
        />
        <span
          // eslint-disable-next-line css-modules/no-undef-class
          className={s.text}
        >
          <FormattedMessage id={isFavorite ? 'В избранном' : 'В избранное'} />
        </span>
      </button>
    );
  }
}

export default withStyles(s)(withFavoritesFetch(withFavorite(Favourite)));



// WEBPACK FOOTER //
// ./src/desktop/components/Favourite/Favourite.js